<template>
  <div id="contribute">
    <h3>Contribute</h3>
    <a class="h5" href="https://github.com/kdaniel21/vue-bootstrap-sidebar">
      GitHub Repository
    </a>
    <p class="mt-3">
      I am looking forward to every contribution to the package. Even if you see
      a typo or something isn't grammatically correct, feel free to open a pull
      request and I'll accept it as soon as possible.
    </p>
    <p>
      If you miss a feature or could improve the code in any way, please don't
      hesitate to fix it so that everyone will have an easier time next time.
    </p>
    <p>
      In case you have a question or just want to have a chat, feel free to
      visit my <a href="https://danielkiss.me">portfolio site</a> or
      <a href="https://danielkiss.me/contact"> get in touch with me </a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Contribute'
};
</script>

<style></style>
